module.exports = __webpack_public_path__ + "img/continue-education.06fdaa9d.png";